import { useMemo } from 'react';
import { useFarmName, useYearsArray } from '../../utils/hooks';
import TableCsvButton from '../tables/TableCsvButton';
import { useFilterContext } from '../../contexts/FilterContext';
import { useSubsidySwitchContext } from '../../contexts/SubsidySwitchContext';
import { isCropFilterValid } from '../../utils/filters';

const ExportYearlyDataButton = ({ data, cols, ...buttonProps }) => {
  const yearsArray = useYearsArray();
  const farmName = useFarmName();
  const { crop: cropFilter } = useFilterContext().state;
  const { shouldShowSubsidies } = useSubsidySwitchContext();
  const cropFilterValid = isCropFilterValid(data, cropFilter);

  // Transform the data into an array with a row for each year
  const transformedData = useMemo(() => {
    if (!data) return null;
    return yearsArray.map((year, i) => ({
      year,
      ...cols.reduce(
        (result, { accessor }) =>
          Object.assign(result, { [accessor]: data[accessor][i] }),
        {},
      ),
    }));
  }, [cols, data, yearsArray]);

  // Add a years column
  const columnsWithYear = useMemo(
    () => [
      { displayString: 'Year', accessor: 'year' },
      ...cols.map((col) => ({ ...col, displayString: col.displayName })),
    ],
    [cols],
  );
  return (
    <TableCsvButton
      title={[
        `${cropFilterValid ? `${cropFilter} ` : ''}Economics`,
        ...(shouldShowSubsidies ? ['subsidies applied'] : []),
        farmName,
      ].join(' - ')}
      data={transformedData}
      cols={columnsWithYear}
      {...buttonProps}
    />
  );
};

export default ExportYearlyDataButton;
